import {
  AttendanceEnumsOvertimeRequestStatusEnum,
  TimesheetOvertimeRequestFragment,
} from 'generated/resources/graphql'

class AttendanceOvertimeUtils {
  static minutes(hoursInCents: number): number {
    return (hoursInCents / 100) * 60
  }

  static hoursAmount(hoursInCents = 0): number {
    return hoursInCents / 100
  }

  static approved(
    overtimeRequests: Partial<TimesheetOvertimeRequestFragment>[]
  ): Partial<TimesheetOvertimeRequestFragment>[] {
    return overtimeRequests.filter((req) => req.status === 'approved')
  }

  static estimatedOvertimeRequestHoursForRange(
    overtimeRequests: Partial<TimesheetOvertimeRequestFragment>[]
  ): number {
    return this.approved(overtimeRequests).reduce(
      (acc, req) => acc + this.hoursAmount(req.hoursAmountInCents),
      0
    )
  }

  static requestedOvertimeMinutes(
    overtimeRequests: Partial<TimesheetOvertimeRequestFragment>[],
    day: string
  ): number {
    const status: AttendanceEnumsOvertimeRequestStatusEnum = 'approved'
    const dayRequest = overtimeRequests?.find((req) => req.status === status && req.date === day)
    const hoursAmount = this.hoursAmount(dayRequest?.hoursAmountInCents)

    return Math.ceil(hoursAmount * 60)
  }
}

export default AttendanceOvertimeUtils
